import Timer from './Timer'
import ActivityTimer from './ActivityTimer'

export default function createActivityTimer(idleCheckMs) {
	const timer = new Timer()
	return new ActivityTimer({ timer, idleCheckMs })
}



// WEBPACK FOOTER //
// ./../jump-common/timers/createActivityTimer.js